<template>
  <div v-scroll-to="anchor" v-show="active" class="topbtn">TOP</div>
</template>
<style scoped>
  .topbtn {
    cursor: pointer;
    width: 80px;
    height: 80px;
    background-color: #aaa;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    border-radius: 100px;
    position: fixed;
    right: 30px;
    bottom: 30px;
    z-index: 99;
  }
</style>
<script>
  export default {
    data() {
      return {
        //アンカーを指定
        anchor: "#pagetop",
        //最初は非表示
        active: false,
      };
    },
    mounted() {
      window.addEventListener("scroll", this.scrollWindow);
    },
    methods: {
      scrollWindow() {
        const top = 100; //100pxスクロールしたらボタンを出す
        this.scroll = window.scrollY; //topからの現在地
        if (top <= this.scroll) {
          this.active = true;
        } else {
          this.active = false;
        }
      },
    },
  };
</script>
